import { NgModule, Type } from '@angular/core';
import { NgbAccordionModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PagesRoutingModule } from './pages.routing';
import { CommonModule } from '@angular/common';
import {
    MissingTranslationHandler,
    TranslateModule,
} from '@ngx-translate/core';
import { PipesModule } from '../../common/pipes/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { ComponentsModule } from '../shared/components/components.module';
import { NgxMaskPipe } from 'ngx-mask';
import { DirectivesModule } from '@/common/directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { UiModule } from '../shared/ui/ui.module';
import { Step3Component } from './step-3/step-3.component';
import { Step4Component } from './step-4/step-4.component';
import { Step1Component } from './step-1/step-1.component';
import { ExtrasDataModule } from '@/data/extras/extras-data.module';
import { GoogleMapsModule } from '@angular/google-maps';
import { InternationalComponent } from './international/international.component';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { BranchesModule } from '@/data/branches/branches-data.module';
import { BranchesInternationalModule } from '@/data/branches-international/branches-international-data.module';
import { Step5Component } from './step-5/step-5.component';
import { DetailsDataModule } from '@/data/details/details-data.module';
import { ViewCancelReservationComponent } from './view-cancel-reservation/view-cancel-reservation.component';
import { Step2Component } from './step-2/step-2.component';
import { BillingDataModule } from '@/data/billing/billing-data.module';
import { PreCheckInComponent } from './pre-check-in/pre-check-in.component';
import { CouponPromotionsComponent } from './coupon-promotions/coupon-promotions.component';
import { PrecheckinComponent } from './landings/precheckin/precheckin.component';
import { OfficialDocumentsDataModule } from '@/data/official-documents/official-documents-data.module';
import { CheckReservationDataModule } from '@/data/check-reservation/check-reservation-data.module';
import { PromotionDataModule } from '@/data/promotion/promotion-data.module';
import { ApiMissingTranslationHandler } from '@/core/translations/api.missing.translation.handler';
import { BlogDataModule } from '@/data/blog/blog-data.module';
import { FaqPageComponent } from './faq-page/faq-page.component';
import { FAQsDataModule } from '@/data/faqs/faqs-data.module';
import { PopularDestinationsDataModule } from '@/data/popular-destinations/popular-destinations-data.module';
import { ResourceCountriesDataModule } from '@/data/resource-countries/resource-countries-data.module';
import { AboutUsComponent } from './about-us/about-us.component';
import { DestinationAirportComponent } from './destination-airport/destination-airport.component';
import { DestinationLocationsComponent } from './destination-locations/destination-locations.component';
import { CountryComponent } from './country/country.component';
import { CityComponent } from './city/city.component';
import { CustomerSupportComponent } from './landings/customer-support/customer-support.component';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { PromotionsComponent } from './promotions/promotions.component';
import { EnterprisesComponent } from './enterprises/enterprises.component';
import { RentalPolicyComponent } from './landings/rental-policy/rental-policy.component';
import { PromotionDetailsDataModule } from '@/data/promotion-details/promotion-details-data.module';
import { TermsUseComponent } from './landings/terms-use/terms-use.component';
import { PrivacyPolicyComponent } from './landings/privacy-policy/privacy-policy.component';
import { RefundsPolicyComponent } from './landings/refunds-policy/refunds-policy.component';
import { DestinationsDataModule } from '@/data/destinations/destinations-data.module';
import { CitiesDataModule } from '@/data/cities/cities-data.module';
import { CountDestinationsDataModule } from '@/data/count-destinations/count-destinations.data.module';
import { CityDetailsDataModule } from '@/data/city-details/city-details-data.module';
import { LocationDetailsDataModule } from '@/data/location-details/location-details-data.module';
import { TermsConditionsComponent } from './landings/terms-conditions/terms-conditions.component';
import { TermsConditionsDataModule } from '@/data/terms-conditions/terms-conditions-data.module';
import { SsrService } from '@/common/services/ssr/ssr.service';
import { StandardOfCareComponent } from './landings/standard-of-care/standard-of-care.component';
import { CoveragesComponent } from './landings/coverages/coverages.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { AdditionalCategoriesServicesComponent } from './additional-categories-services/additional-categories-services.component';
import { CarsDataModule } from '@/data/cars/cars-data.module';
import { CrpDataModule } from '@/data/car-rental-policy/crp-data.module';
import { SpecialOffersEmailComponent } from './special-offers-email/special-offers-email.component';
import { LandingVacationComponent } from './landings/landing-vacation/landing-vacation.component';
import { RentalFlexibleComponent } from './landings/rental-flexible/rental-flexible.component';
import { LeaseComponent } from './landings/lease/lease.component';
import { LeasingComponent } from './landings/leasing/leasing.component';
import { TypesCarComponent } from './landings/types-car/types-car.component';
import { AlamoRewardsComponent } from './alamo-rewards/alamo-rewards.component';
import { EnterprisesLpComponent } from './enterprises-lp/enterprises-lp.component';
import { LandingRewardsDataModule } from '@/data/landing-rewards/landing-rewards-data.module';

@NgModule({
    declarations: [
        Step2Component,
        Step3Component,
        Step4Component,
        Step5Component,
        Step1Component,
        InternationalComponent,
        ViewCancelReservationComponent,
        PreCheckInComponent,
        CouponPromotionsComponent,
        PrecheckinComponent,
        FaqPageComponent,
        AboutUsComponent,
        DestinationAirportComponent,
        DestinationLocationsComponent,
        CountryComponent,
        CityComponent,
        CustomerSupportComponent,
        PromotionsComponent,
        EnterprisesComponent,
        RentalFlexibleComponent,
        LeaseComponent,
        LeasingComponent,
        TypesCarComponent,
        RentalPolicyComponent,
        TermsUseComponent,
        PrivacyPolicyComponent,
        RefundsPolicyComponent,
        TermsConditionsComponent,
        StandardOfCareComponent,
        CoveragesComponent,
        MaintenanceComponent,
        AdditionalCategoriesServicesComponent,
        SpecialOffersEmailComponent,
        LandingVacationComponent,
        AlamoRewardsComponent,
        EnterprisesLpComponent,
    ],
    exports: [
        Step2Component,
        Step3Component,
        InternationalComponent,
        PromotionsComponent,
    ],
    imports: [
        CommonModule,
        NgbModule,
        PagesRoutingModule,
        TranslateModule.forChild({
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: ApiMissingTranslationHandler,
                deps: [SsrService],
            },
            extend: true,
        }),
        SharedModule,
        ComponentsModule,
        PipesModule,
        NgxMaskPipe,
        DirectivesModule,
        ReactiveFormsModule,
        FormsModule,
        NgSelectModule,
        UiModule,
        GoogleMapsModule,
        ExtrasDataModule,
        SweetAlert2Module,
        BranchesModule,
        BranchesInternationalModule,
        DetailsDataModule,
        BillingDataModule,
        OfficialDocumentsDataModule,
        CheckReservationDataModule,
        PromotionDataModule,
        BlogDataModule,
        NgbAccordionModule,
        FAQsDataModule,
        PopularDestinationsDataModule,
        ResourceCountriesDataModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        DestinationsDataModule,
        CitiesDataModule,
        CountDestinationsDataModule,
        CityDetailsDataModule,
        PromotionDetailsDataModule,
        LocationDetailsDataModule,
        TermsConditionsDataModule,
        LandingRewardsDataModule,
        CarsDataModule,
        CrpDataModule,
    ],
    providers: [],
    bootstrap: [],
})
export class PagesModule {}
